// src/i18n/config.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './locales/en';
import { fi } from './locales/fi';

const mergeTranslations = (fallback, primary) => {
  const merged = { ...fallback };

  Object.entries(primary).forEach(([key, value]) => {
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      fallback[key] &&
      typeof fallback[key] === 'object' &&
      !Array.isArray(fallback[key])
    ) {
      merged[key] = mergeTranslations(fallback[key], value);
    } else {
      merged[key] = value;
    }
  });

  return merged;
};

const resources = {
  fi: { translation: mergeTranslations(en, fi) },
  en: { translation: mergeTranslations(fi, en) },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ['fi', 'en'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
